import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { tacticNameToWrapperMap } from '../tacticMap/TacticNameToWrapperMap';
interface Map {
  [index: string]: any;
}
interface Props {
  tradePlanId?: string;
  symbol?: string;
  softOrderId?: string;
  componentMap?: Map
}
const SoftOrderWrapper: React.FC<Props> = observer(({ symbol, softOrderId, componentMap, ...rest }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const softOrder = tradePlanStore.softOrdersById[softOrderId];
  const tacticName = softOrder.value.tactic;
  const Wrapper = tacticNameToWrapperMap[tacticName];
  const component = componentMap[tacticName];
  if (symbol === 'tacticsPanel') return <Wrapper softOrderId={softOrderId} softOrder={softOrder.value.tacticValue} Component={component} completeSoftOrder={softOrder} {...rest}/>;
  if (softOrder.value.symbol !== symbol) return null;
  return <Wrapper softOrderId={softOrderId} softOrder={softOrder.value.tacticValue} Component={component} completeSoftOrder={softOrder} {...rest}/>;
});


export default SoftOrderWrapper;
